import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "rgba(0,0,0,.30)",
    backdropFilter: "blur(10px)", // Ajuste o valor de '10px' de acordo com o efeito desejado.
  },
  appBar: {
    background:
      "linear-gradient(to bottom,rgba(0,0,0,.65) 0%,transparent 100%)",
  },
  title: { flex: 1, color: "#FFF" },
  imageContainer: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    overflow: "hidden",
    height: "90dvh",
    objectFit: "contain",
    borderRadius: "8px",
  },
}));

export default useStyles;
